import React, { useState } from 'react'
import { Box, CircularProgress } from '@mui/material'
import TeleconsultationCard from './TeleconsultationCard'
import ButtonDashboard from '../../../../components/ButtonDashboard'
import UserService from '../../../../api/gerep/UserService'
import GerepAPI from '../../../../api/gerep/GerepAPI'
import LocalStorage from '../../../../business/storage/LocalStorage'
import appConst from '../../../../constant/appConstants'

type WeliiBlockProps = {
	service: any
}

/**
 * Bloc du service Welii.
 *
 * Sur le même principe que OauthPage : on échange le ticket de l'utilisateur
 * contre un authorization code via `/loginAuthCode/welii`, puis on redirige vers
 * Welii avec le code, l'état de session et l'issuer retournés par ce service.
 *
 * L'URL de Welii vient de `appConst.weliiUrl`, alimentée par
 * `window.__WELII_URL__`, comme `passConnectUrl` l'est par
 * `window.__PASSCONNECT_URL__`.
 */
const WeliiBlock: React.FC<WeliiBlockProps> = ({ service }) => {
	const [isLoading, setIsLoading] = useState<boolean>(false)

	const buttonLibelle = service?.libelleLienWeb || 'Accédez au site'
	// On ne garde que la partie de l'URL qui précède le `?` : la query string est
	// reconstruite plus bas avec code, session_state et iss.
	const redirectUri = `${appConst.weliiUrl}`.split('?')[0]

	const redirectToWelii = () => {
		setIsLoading(true)
		// L'onglet est ouvert de façon synchrone au clic pour ne pas être bloqué
		// par le bloqueur de pop-up, puis redirigé une fois le code obtenu.
		const weliiWindow = window.open('', '_blank')
		if (weliiWindow) {
			weliiWindow.opener = null
		}
		UserService.getAuthCode(LocalStorage.getToken())
			.then((weakToken: string) => GerepAPI.post(
				'/loginAuthCode/welii',
				{ token: weakToken, redirectUri: appConst.weliiUrl, nonce: '' },
				LocalStorage.getToken(),
				true
			))
			.then((authCodeReponse: any) => {
				const params = new URLSearchParams()
				params.append('session_state', authCodeReponse?.session_state || '')
				params.append('code', authCodeReponse?.code || '')
				params.append('iss', authCodeReponse?.issuer || '')
				const url = `${redirectUri}?${params.toString()}`
				if (weliiWindow) {
					weliiWindow.location.href = url
				} else {
					window.open(url, '_blank', 'noopener,noreferrer')
				}
			})
			.catch(() => weliiWindow?.close())
			.finally(() => setIsLoading(false))
	}

	return (
		<TeleconsultationCard
			service={service}
			simulateur={false}
			lienWebCustom={
				<Box display="flex" width="100%" justifyContent="center">
					<ButtonDashboard variant="outlined" disabled={isLoading} onClick={redirectToWelii}>
						{isLoading ? <CircularProgress size={24} color="inherit" /> : buttonLibelle}
					</ButtonDashboard>
				</Box>
			}
		/>
	)
}

export default WeliiBlock
